import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SegmentPool_instanceps1mclk6cv3l as SegmentPool_instance } from './SegmentPool.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.p4h_1 = 8192;
        this.q4h_1 = 1024;
      }
      r4h() {
        return Segment().s4h();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_kotlinx_io_Segment(_this__u8e3s4) {
  _this__u8e3s4.q4f_1 = 0;
  _this__u8e3s4.r4f_1 = 0;
  _this__u8e3s4.s4f_1 = null;
  _this__u8e3s4.t4f_1 = false;
  _this__u8e3s4.u4f_1 = null;
  _this__u8e3s4.v4f_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      u4g() {
        var tmp0_safe_receiver = this.s4f_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t4h();
        return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
      }
      static s4h() {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.p4f_1 = new Int8Array(8192);
        $this.t4f_1 = true;
        $this.s4f_1 = null;
        return $this;
      }
      static u4h(data, pos, limit, shareToken, owner) {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.p4f_1 = data;
        $this.q4f_1 = pos;
        $this.r4f_1 = limit;
        $this.s4f_1 = shareToken;
        $this.t4f_1 = owner;
        return $this;
      }
      c4g() {
        var tmp0_elvis_lhs = this.s4f_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = SegmentPool_instance.v4h();
          this.s4f_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var t = tmp;
        var tmp_0 = this.q4f_1;
        var tmp_1 = this.r4f_1;
        // Inline function 'kotlin.also' call
        t.w4h();
        return Segment().u4h(this.p4f_1, tmp_0, tmp_1, t, false);
      }
      x4g() {
        var result = this.u4f_1;
        if (!(this.v4f_1 == null)) {
          ensureNotNull(this.v4f_1).u4f_1 = this.u4f_1;
        }
        if (!(this.u4f_1 == null)) {
          ensureNotNull(this.u4f_1).v4f_1 = this.v4f_1;
        }
        this.u4f_1 = null;
        this.v4f_1 = null;
        return result;
      }
      d4g(segment) {
        segment.v4f_1 = this;
        segment.u4f_1 = this.u4f_1;
        if (!(this.u4f_1 == null)) {
          ensureNotNull(this.u4f_1).v4f_1 = segment;
        }
        this.u4f_1 = segment;
        return segment;
      }
      v4g(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.r4f_1 - this.q4f_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().n2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.c4g();
        } else {
          prefix = SegmentPool_instance.d3x();
          var tmp0 = this.p4f_1;
          var tmp2 = prefix.p4f_1;
          var tmp5 = this.q4f_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.q4f_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.r4f_1 = prefix.q4f_1 + byteCount | 0;
        this.q4f_1 = this.q4f_1 + byteCount | 0;
        if (!(this.v4f_1 == null)) {
          ensureNotNull(this.v4f_1).d4g(prefix);
        } else {
          prefix.u4f_1 = this;
          this.v4f_1 = prefix;
        }
        return prefix;
      }
      e4g() {
        // Inline function 'kotlin.check' call
        if (!!(this.v4f_1 == null)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.v4f_1).t4f_1)
          return this;
        var byteCount = this.r4f_1 - this.q4f_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.v4f_1).r4f_1 | 0) + (ensureNotNull(this.v4f_1).u4g() ? 0 : ensureNotNull(this.v4f_1).q4f_1) | 0;
        if (byteCount > availableByteCount)
          return this;
        var predecessor = this.v4f_1;
        this.w4g(ensureNotNull(predecessor), byteCount);
        var successor = this.x4g();
        // Inline function 'kotlin.check' call
        if (!(successor == null)) {
          throw IllegalStateException().o('Check failed.');
        }
        SegmentPool_instance.e4h(this);
        return predecessor;
      }
      a4h(byte) {
        var _unary__edvuaz = this.r4f_1;
        this.r4f_1 = _unary__edvuaz + 1 | 0;
        this.p4f_1[_unary__edvuaz] = byte;
      }
      c4h(short) {
        var data = this.p4f_1;
        var limit = this.r4f_1;
        var _unary__edvuaz = limit;
        limit = _unary__edvuaz + 1 | 0;
        data[_unary__edvuaz] = toByte((short >>> 8 | 0) & 255);
        var _unary__edvuaz_0 = limit;
        limit = _unary__edvuaz_0 + 1 | 0;
        data[_unary__edvuaz_0] = toByte(short & 255);
        this.r4f_1 = limit;
      }
      x4f() {
        var _unary__edvuaz = this.q4f_1;
        this.q4f_1 = _unary__edvuaz + 1 | 0;
        return this.p4f_1[_unary__edvuaz];
      }
      z4f() {
        var data = this.p4f_1;
        var pos = this.q4f_1;
        var _unary__edvuaz = pos;
        pos = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp = (data[_unary__edvuaz] & 255) << 8;
        var _unary__edvuaz_0 = pos;
        pos = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp$ret$1 = data[_unary__edvuaz_0] & 255;
        var s = toShort(tmp | tmp$ret$1);
        this.q4f_1 = pos;
        return s;
      }
      w4g(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.t4f_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.r4f_1 + byteCount | 0) > 8192) {
          if (sink.u4g())
            throw IllegalArgumentException().od();
          if (((sink.r4f_1 + byteCount | 0) - sink.q4f_1 | 0) > 8192)
            throw IllegalArgumentException().od();
          var tmp0 = sink.p4f_1;
          var tmp2 = sink.p4f_1;
          var tmp5 = sink.q4f_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.r4f_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.r4f_1 = sink.r4f_1 - sink.q4f_1 | 0;
          sink.q4f_1 = 0;
        }
        var tmp0_0 = this.p4f_1;
        var tmp2_0 = sink.p4f_1;
        var tmp4 = sink.r4f_1;
        var tmp6 = this.q4f_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.q4f_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.r4f_1 = sink.r4f_1 + byteCount | 0;
        this.q4f_1 = this.q4f_1 + byteCount | 0;
      }
      i4g(dst, dstStartOffset, dstEndOffset) {
        var len = dstEndOffset - dstStartOffset | 0;
        var tmp0 = this.p4f_1;
        var tmp6 = this.q4f_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = this.q4f_1 + len | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = tmp0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, dst, dstStartOffset, tmp6, endIndex);
        this.q4f_1 = this.q4f_1 + len | 0;
      }
      s4g(src, srcStartOffset, srcEndOffset) {
        var tmp2 = this.p4f_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destinationOffset = this.r4f_1;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = src;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, tmp2, destinationOffset, srcStartOffset, srcEndOffset);
        this.r4f_1 = this.r4f_1 + (srcEndOffset - srcStartOffset | 0) | 0;
      }
      q2() {
        return this.r4f_1 - this.q4f_1 | 0;
      }
      r4g() {
        return this.p4f_1.length - this.r4f_1 | 0;
      }
      x4h(readOnly) {
        return this.p4f_1;
      }
      g4g(index) {
        return this.p4f_1[this.q4f_1 + index | 0];
      }
      y4h(index, value) {
        this.p4f_1[this.r4f_1 + index | 0] = value;
      }
      z4h(index, b0, b1) {
        var d = this.p4f_1;
        var l = this.r4f_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
      }
      a4i(index, b0, b1, b2) {
        var d = this.p4f_1;
        var l = this.r4f_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
      }
      b4i(index, b0, b1, b2, b3) {
        var d = this.p4f_1;
        var l = this.r4f_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
        d[(l + index | 0) + 3 | 0] = b3;
      }
    }
    initMetadataForClass($, 'Segment');
    SegmentClass = $;
  }
  return SegmentClass;
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.q2() === 0;
}
var SegmentCopyTrackerClass;
function SegmentCopyTracker() {
  if (SegmentCopyTrackerClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SegmentCopyTracker');
    SegmentCopyTrackerClass = $;
  }
  return SegmentCopyTrackerClass;
}
var AlwaysSharedCopyTrackerClass;
function AlwaysSharedCopyTracker() {
  if (AlwaysSharedCopyTrackerClass === VOID) {
    class $ extends SegmentCopyTracker() {
      constructor() {
        AlwaysSharedCopyTracker_instance = null;
        super();
        AlwaysSharedCopyTracker_instance = this;
      }
      t4h() {
        return true;
      }
      w4h() {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'AlwaysSharedCopyTracker');
    AlwaysSharedCopyTrackerClass = $;
  }
  return AlwaysSharedCopyTrackerClass;
}
var AlwaysSharedCopyTracker_instance;
function AlwaysSharedCopyTracker_getInstance() {
  if (AlwaysSharedCopyTracker_instance === VOID)
    new (AlwaysSharedCopyTracker())();
  return AlwaysSharedCopyTracker_instance;
}
function indexOf(_this__u8e3s4, byte, startOffset, endOffset) {
  // Inline function 'kotlin.require' call
  if (!(0 <= startOffset ? startOffset < _this__u8e3s4.q2() : false)) {
    var message = '' + startOffset;
    throw IllegalArgumentException().n2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(startOffset <= endOffset ? endOffset <= _this__u8e3s4.q2() : false)) {
    var message_0 = '' + endOffset;
    throw IllegalArgumentException().n2(toString(message_0));
  }
  var p = _this__u8e3s4.q4f_1;
  var data = _this__u8e3s4.x4h(true);
  var inductionVariable = startOffset;
  if (inductionVariable < endOffset)
    do {
      var idx = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (data[p + idx | 0] === byte) {
        return idx;
      }
    }
     while (inductionVariable < endOffset);
  return -1;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  AlwaysSharedCopyTracker_getInstance as AlwaysSharedCopyTracker_getInstance1rs3z6uqvhgfu,
  Companion_instance as Companion_instancecsbm5ewxyfnq,
  indexOf as indexOf1i2yqitz2lwb6,
  isEmpty as isEmpty39cntv762vey6,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
